// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603230936/js/" + chunkId + "." + {"44":"7ae02c0e","225":"3cbb5441","481":"6cf17ab8","486":"69473df1","770":"519c8846"}[chunkId] + ".0.11109427261520644.chunk.js";
};